// extracted by mini-css-extract-plugin
export default {"label":"GroupLabel_label__n47Oq","small":"GroupLabel_small__Acu02","medium":"GroupLabel_medium__CkElm","large":"GroupLabel_large__TxUAE","dot":"GroupLabel_dot__0ZrDD"};